import { DAIMI_BK_INTRO, DAIMI_BK_SLUG } from '@/content/daimiBanking'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The eighth report with a designed page of its own, and the fourth whose
  // own copy was supplied rather than paraphrased — asked for on 2026-08-27
  // (*"banking focus report"*), hours after the Automotive cut and with the
  // same five attachments: two screenshots of the live page, the cover at
  // 2560px, Figure 1 and the report mockup. See `content/daimiBanking.ts` and
  // `pages/DaimiBanking.tsx`.
  ...focus(
    DAIMI_BK_SLUG,
    'Banking',
    'daimi-report-2026-banking-cover',
    '37f90adb-cf19-45a8-b5fc-33ba828c58f3-digitopia-daimi-2026-report-banking.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference screenshots and
  // held on the page that says them — so the search result and the page cannot
  // drift apart. `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_BK_INTRO.body,
  layout: 'banking-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section
  // on its page, and `daimiBankingChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 6
